import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "../../../App";
import { exportToExcel } from "./exportToExcel";
import {
  getLoggenInToken,
  getLoggedInUser,
} from "../../../store/selectors/AuthSelectors";
import { Col, Row, Modal, Button, Spinner } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import { Dropdown } from "react-bootstrap";
import { getCandidates } from "../../../store/selectors/Candidates/CandidatesList";
import SendEmail from "../Common/SendEmail";
import SendLetter from "../Common/SendLetter";
import { dateFormat } from "../../../utils/date";
import { post } from "../../../services/api";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { del } from "../../../services/api";
import Status from "../Common/Status";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";

const SearchCandidate = ({ token, loggedInUser }) => {
  const nav = useNavigate();
  const location = useLocation();
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const userdata = useRef();
  const sendletterref = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 10;
  const [searched, setsearched] = useState(false);
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const [candidates, setcandidates] = useState([]);
  const [text, settext] = useState();
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [showCompanySelector, setShowCompanySelector] = useState(false);
  const npage = Math.ceil(candidates?.length / recordsPage);
  const handleEmailAction = (action) => {
    if (isAuthenticated) {
      action();
    } else {
      swal({
        title: "Email Not Synced",
        text: "Please sync your email first.",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          sync: {
            text: "Sync Email",
            value: "sync",
          },
        },
      }).then((value) => {
        if (value === "sync") {
          instance.loginPopup(loginRequest).catch((e) => {
            console.error(e);
          });
        }
      });
    }
  };

  // Fetch companies for filtering
  const fetchCompanies = async () => {
    try {
      const response = await fetch('http://localhost:8080/api/candidate/companies-for-filter', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.success) {
        setAvailableCompanies(data.companies);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };
  const number = [...Array(npage + 1).keys()].slice(1);
  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }
  const options = [
    { value: "firstName", label: "First Name" },
    { value: "lastName", label: "Last Name" },
    { value: "knownAs", label: "Known As" },
    { value: "address.town", label: "Town" },
    { value: "address.county", label: "County" },
    { value: "address.country", label: "Country" },
    { value: "address.postcode", label: "Postcode" },
    { value: "address.region", label: "Region" },
    { value: "email", label: "Email" },
    { value: "hasVehicle", label: "Does the candidate have vehicle ?" },
    { value: "vehicleLicense", label: "Vehicle License" },
    {
      value: "hasDrivingLicense",
      label: "Does the candidate have driving license ?",
    },
    { value: "drivingLicense", label: "Driving License" },
    { value: "enrollMentExpiryDate", label: "Enrolment Letter Expiry Date" },
    { value: "rtwExpiryDate", label: "RTW Check Expiry Date" },
    { value: "qualifications", label: "Qualifications" },
    { value: "contact.phoneNumber", label: "Mobile Number" },
    { value: "source", label: "Source" },
    { value: "regDate", label: "Registration Date" },
    { value: "dateOfBirth", label: "Date of Birth" },
    { value: "status", label: "Status" },
    { value: "previouslyWorkedByCompany", label: "Previously Worked by Company" },
  ];
  // Parse URL search params on component mount
  const parseSearchParams = () => {
    const params = new URLSearchParams(location.search);
    if (params.toString()) {
      const ands = [];
      const ors = [];
      let andIndex = 0;
      let orIndex = 0;

      // Check if there are any search params
      let hasParams = false;

      // Parse AND conditions
      while (params.has(`and_${andIndex}_field`)) {
        const field = params.get(`and_${andIndex}_field`);
        if (params.has(`and_${andIndex}_startDate`)) {
          // Handle date range
          const startDate = new Date(params.get(`and_${andIndex}_startDate`));
          const endDate = new Date(params.get(`and_${andIndex}_endDate`));
          ands.push({
            idx: andIndex,
            field,
            startDate,
            endDate
          });
        } else {
          // Handle regular value
          const value = params.get(`and_${andIndex}_value`);
          ands.push({
            idx: andIndex,
            field,
            value
          });
        }
        andIndex++;
        hasParams = true;
      }

      // Parse OR conditions
      while (params.has(`or_${orIndex}_field`)) {
        const field = params.get(`or_${orIndex}_field`);
        if (params.has(`or_${orIndex}_startDate`)) {
          // Handle date range
          const startDate = new Date(params.get(`or_${orIndex}_startDate`));
          const endDate = new Date(params.get(`or_${orIndex}_endDate`));
          ors.push({
            idx: orIndex,
            field,
            startDate,
            endDate
          });
        } else {
          // Handle regular value
          const value = params.get(`or_${orIndex}_value`);
          ors.push({
            idx: orIndex,
            field,
            value
          });
        }
        orIndex++;
        hasParams = true;
      }

      if (hasParams) {
        return { ands, ors };
      }
    }
    return null;
  };

  // Initialize state with parsed URL params or default values
  const [searchAnds, setSearchAnds] = useState(parseSearchParams()?.ands || [{ idx: 0 }]);
  const [searchOrs, setSearchOrs] = useState(parseSearchParams()?.ors || []);
  const [isManualSearch, setIsManualSearch] = useState(false);

  
  // Effect to handle initial search if URL has params
  useEffect(() => {
    const params = parseSearchParams();
    if (params && !isManualSearch) {
      const performSearch = async () => {
        try {
          const res = await post(
            "/api/candidate/search",
            { search: params.ands, orsearch: params.ors },
            token
          );
          
          if (res?.data?.length > 0) {
            setcandidates(res.data);
            setsearched(true);
          } else {
            setcandidates([]);
            setsearched(false);
          }
        } catch (error) {
          console.error("Initial search error:", error);
          setcandidates([]);
          setsearched(false);
        }
      };
      
      if (params.ands.length > 0) {
        performSearch();
      }
    }
    setIsManualSearch(false);
  }, [location.search]);
  const [ai, setAi] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [checked, setChecked] = useState([]);
  const [unchecked, setUnChecked] = useState(true);
  useEffect(() => {
    setChecked(
      candidates?.slice(firstIndex, lastIndex).map((candidate) => ({
        ...candidate,
        inputchecked: false,
      }))
    );
  }, [candidates, currentPage]);
  useEffect(() => {
    setCurrentPage(1); // Reset to first page on data update
  }, [candidates]);
  const handleChecked = (id) => {
    setChecked((prevChecked) =>
      prevChecked.map((candidate) =>
        candidate._id === id
          ? { ...candidate, inputchecked: !candidate.inputchecked }
          : candidate
      )
    );
  };
  const handleCheckedAll = (value) => {
    let temp = checked.map((data) => {
      return { ...data, inputchecked: value };
    });
    setChecked(temp);
    setUnChecked(!unchecked);
  };

  const handleInputChange = (idx, field, value) => {
    const serach = [...searchAnds];
    const seechedObject = serach[idx];
    seechedObject[field] = value;
    serach[idx] = seechedObject;
    setSearchAnds(serach);
  };

  const handleInputChange2 = (idx, field, value) => {
    const serach = [...searchOrs];
    const seechedObject = serach[idx];
    seechedObject[field] = value;
    serach[idx] = seechedObject;
    setSearchOrs(serach);
  };

  const searchData = async () => {
  if (isLoading) return;
  setIsLoading(true);
  setIsManualSearch(true);
  // Clear previous results while loading new ones
  setcandidates([]);
  setChecked([]);

  try {
    const formatDate = (date) =>
      date ? new Date(date).toISOString().split("T")[0] : null;
    
    const processSearchFilters = (filters) =>
      filters
        .filter((s) => s.field && (s.value || (s.startDate && s.endDate)))
        .map((s) => {
          if (s.startDate && s.endDate) {
            return {
              ...s,
              value: {
                startDate: formatDate(s.startDate),
                endDate: formatDate(s.endDate),
              },
            };
          }
          return s;
        });

    // Check if we have company filtering
    const companyFilter = searchAnds.find(s => s.field === 'previouslyWorkedByCompany' && s.value);
    const orCompanyFilter = searchOrs.find(s => s.field === 'previouslyWorkedByCompany' && s.value);
    
    if (companyFilter || orCompanyFilter) {
      // Handle company-based search
      const companyIds = companyFilter ? companyFilter.value : orCompanyFilter.value;
      const searchTerm = searchAnds.find(s => s.field !== 'previouslyWorkedByCompany' && s.value)?.value || 
                        searchOrs.find(s => s.field !== 'previouslyWorkedByCompany' && s.value)?.value || '';
      
      const response = await fetch(`http://localhost:8080/api/candidate/by-company?companyIds=${companyIds}&searchTerm=${searchTerm}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      
      if (data.success) {
        setcandidates(data.candidates);
        setsearched(true);
      } else {
        setcandidates([]);
        setsearched(false);
      }
      return;
    }

    const body = processSearchFilters(searchAnds);
    const orbody = processSearchFilters(searchOrs);

    if (body.length > 0) {
      // Create URL search params
      const params = new URLSearchParams();
      
      body.forEach((filter, index) => {
        if (filter.value && typeof filter.value === 'object') {
          params.append(`and_${index}_field`, filter.field);
          params.append(`and_${index}_startDate`, filter.value.startDate);
          params.append(`and_${index}_endDate`, filter.value.endDate);
        } else if (filter.value) {
          params.append(`and_${index}_field`, filter.field);
          params.append(`and_${index}_value`, filter.value);
        }
      });

      orbody.forEach((filter, index) => {
        if (filter.value && typeof filter.value === 'object') {
          params.append(`or_${index}_field`, filter.field);
          params.append(`or_${index}_startDate`, filter.value.startDate);
          params.append(`or_${index}_endDate`, filter.value.endDate);
        } else if (filter.value) {
          params.append(`or_${index}_field`, filter.field);
          params.append(`or_${index}_value`, filter.value);
        }
      });

      // Update URL first with replace: true to prevent history entry
      nav(`/search-candidate?${params.toString()}`, { replace: true });

      // Then perform the search
      const res = await post(
        "/api/candidate/search",
        { search: body, orsearch: orbody },
        token
      );
      
      if (res?.data) {
        setcandidates(res.data);
        setsearched(true);
      } else {
        setcandidates([]);
        setsearched(false);
      }
    }
  } catch (error) {
    console.error("Search error:", error);
    toast.error("Error performing search");
    setcandidates([]);
    setsearched(false);
  } finally {
    setIsLoading(false);
  }
};

  const searchAi = async () => {
    setIsLoading(true);
    const res = await post("/api/candidate/search-ai", { text }, token);
    setcandidates(res?.data);
    setsearched(true);
    setIsLoading(false);
    setAi(false);
  };

  return (
    <>
      <div className="container-fluid">
        <Row>
          <Col lg="12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Search Candidates</h4>
              </div>
              <div className="card-body">
                <div className="row">
                  {searchAnds.map((search, idx) => {
                    return (
                      <>
                        {idx !== 0 && (
                          <div className="col-xl-1 mb-1">
                            <h3
                              style={{ marginTop: "20px", paddingLeft: "10px" }}
                            >
                              AND
                            </h3>
                          </div>
                        )}
                        <div
                          className="col-xl-5 mb-5 grid-col"
                          style={{ paddingBottom: "10px", borderRadius: "5px" }}
                        >
                          <div className="row">
                            <div className="col-xl-6 mb-6">
                              <>
                                <label className="form-label">Search For</label>
                                <select
                                  value={search?.field || ""}
                                  className="form-control"
                                  onChange={(e) =>
                                    handleInputChange(
                                      idx,
                                      "field",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value={null}>Select</option>
                                  {options?.map((itm) => (
                                    <option value={itm.value}>
                                      {itm.label}
                                    </option>
                                  ))}
                                  {/* {options?.filter(o=>  !searchAnds.filter(s=> s.idx != idx).map(s=>s.field).includes(o.value))?.map((itm) => (
                                         <option value={itm.value}>{itm.label}</option>
                                       ))} */}
                                </select>
                              </>
                            </div>
                            <div className="col-xl-6 mb-6">
                              {search?.field === "previouslyWorkedByCompany" ? (
                                <>
                                  <label className="form-label">Select Companies</label>
                                  <button
                                    type="button"
                                    className="form-control btn btn-outline-primary"
                                    onClick={() => {
                                      fetchCompanies();
                                      setShowCompanySelector(true);
                                    }}
                                  >
                                    {selectedCompanies.length > 0 
                                      ? `${selectedCompanies.length} companies selected`
                                      : 'Click to select companies'
                                    }
                                  </button>
                                  {selectedCompanies.length > 0 && (
                                    <div className="mt-2">
                                      {selectedCompanies.map(company => (
                                        <span key={company._id} className="badge bg-primary me-1">
                                          {company.companyName}
                                          <button
                                            type="button"
                                            className="btn-close btn-close-white ms-1"
                                            onClick={() => {
                                              const updated = selectedCompanies.filter(c => c._id !== company._id);
                                              setSelectedCompanies(updated);
                                              handleInputChange(idx, "value", updated.map(c => c._id).join(','));
                                            }}
                                          ></button>
                                        </span>
                                      ))}
                                    </div>
                                  )}
                                </>
                              ) : search?.field === "regDate" ||
                              search?.field === "dateOfBirth" ||
                              search?.field === "enrollMentExpiryDate" ||
                              search?.field === "rtwExpiryDate" ? (
                                <>
                                  <label className="form-label">
                                    From 
                                  </label>
                                  <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={search?.startDate}
                                    onChange={(date) =>
                                      handleInputChange(idx, "startDate", date)
                                    }
                                    className="form-control"
                                    placeholderText="Select start date"
                                  />

                                  <label className="form-label">To</label>
                                  <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={search?.endDate}
                                    onChange={(date) =>
                                      handleInputChange(idx, "endDate", date)
                                    }
                                    className="form-control"
                                    placeholderText="Select end date"
                                  />
                                </>
                              ) : (
                                <>
                                  <label className="form-label">
                                    Equals to
                                  </label>
                                  <input
                                    type="text"
                                    value={search?.value || ""}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleInputChange(
                                        idx,
                                        "value",
                                        e.target.value
                                      )
                                    }
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}

                  {searchOrs.map((search, idx) => {
                    return (
                      <>
                        <div className="col-xl-1 mb-1">
                          <h3
                            style={{ marginTop: "20px", paddingLeft: "10px" }}
                          >
                            OR
                          </h3>
                        </div>
                        <div
                          className="col-xl-5 mb-5 grid-col"
                          style={{ paddingBottom: "10px", borderRadius: "5px" }}
                        >
                          <div className="row">
                            <div className="col-xl-6 mb-6">
                              <>
                                <label className="form-label">Search For</label>
                                <select
                                  value={search?.field || ""}
                                  className="form-control"
                                  onChange={(e) =>
                                    handleInputChange2(
                                      idx,
                                      "field",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value={null}>Select</option>
                                  {options?.map((itm) => (
                                    <option value={itm.value}>
                                      {itm.label}
                                    </option>
                                  ))}
                                  {/* {options?.filter(o=>  !searchAnds.filter(s=> s.idx != idx).map(s=>s.field).includes(o.value))?.map((itm) => (
                                         <option value={itm.value}>{itm.label}</option>
                                       ))} */}
                                </select>
                              </>
                            </div>
                            <div className="col-xl-6 mb-6">
                              {search?.field === "regDate" ||
                              search?.field === "dateOfBirth" ||
                              search?.field === "enrollMentExpiryDate" ||
                              search?.field === "rtwExpiryDate" ? (
                                <>
                                  <label className="form-label">
                                    Start Date
                                  </label>
                                  <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={search?.startDate}
                                    onChange={(date) =>
                                      handleInputChange2(idx, "startDate", date)
                                    }
                                    className="form-control"
                                    placeholderText="Select start date"
                                  />

                                  <label className="form-label">End Date</label>
                                  <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={search?.endDate}
                                    onChange={(date) =>
                                      handleInputChange2(idx, "endDate", date)
                                    }
                                    className="form-control"
                                    placeholderText="Select end date"
                                  />
                                </>
                              ) : (
                                <>
                                  <label className="form-label">
                                    Equals to
                                  </label>
                                  <input
                                    type="text"
                                    value={search?.value || ""}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleInputChange2(
                                        idx,
                                        "value",
                                        e.target.value
                                      )
                                    }
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}

                  <div className="col-xl-6 mb-6">
                    <div style={{ marginTop: "20px" }}>
                      {!searched && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() => {
                            const ands = [...searchAnds];
                            ands.push({ idx: ands.length });
                            setSearchAnds(ands);
                          }}
                        >
                          <i className="fa-solid fa-plus me-2"></i>
                          AND
                        </button>
                      )}
                      {!searched && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() => {
                            const ors = [...searchOrs];
                            ors.push({ idx: ors.length });
                            setSearchOrs(ors);
                          }}
                        >
                          <i className="fa-solid fa-plus me-2"></i>
                          OR
                        </button>
                      )}
                      {!searched && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={searchData}
                        >
                          <i className="fa-solid fa-search me-2"></i>
                          Search
                        </button>
                      )}

                      <button
                        className="btn btn-primary me-2"
                        onClick={() => {
                          setsearched(false);
                          setcandidates([]);
                          setSearchAnds([{ idx: 0 }]);
                          setSearchOrs([]);
                        }}
                      >
                        <i className="fa-solid fa-close me-2"></i>
                        Clear
                      </button>
                      {searched && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() =>
                            handleEmailAction(() =>
                              userdata.current.showEmailModal()
                            )
                          }
                          disabled={
                            checked.filter((d) => d.inputchecked)?.length === 0
                          }
                        >
                          <i className="fa-solid fa-envelope me-2"></i>
                          Send Mail
                        </button>
                      )}
                      {searched && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() =>
                            handleEmailAction(() =>
                              sendletterref.current.showLetterModal()
                            )
                          }
                          disabled={
                            checked.filter((d) => d.inputchecked)?.length === 0
                          }
                        >
                          <i className="fa-solid fa-envelope me-2"></i>
                          Send Letter
                        </button>
                      )}

                      {searched && (
                        <button
                          onClick={() =>
                            exportToExcel(
                              checked.filter((itm) => itm.inputchecked).length >
                                0
                                ? checked.filter((itm) => itm.inputchecked)
                                : candidates
                            )
                          }
                          className="btn btn-primary light btn-sm me-2"
                        >
                          <i className="fa-solid fa-file-excel" /> Export Report
                        </button>
                      )}

                      {!searched && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() => {
                            setAi(true);
                            settext();
                          }}
                        >
                          <i className="fa-solid fa-robot me-2"></i>
                          AI
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  {candidates.length > 0 ? (
                      <div className="tbl-caption">
                        <h4 className="heading mb-0">Searched Result</h4>
                      </div>
                    ) : searched && (
                      <div className="tbl-caption">
                        <h4 className="heading mb-0">No results found</h4>
                      </div>
                    )}
                    {isLoading && (
                    <div className="text-center my-4">
                      <Spinner animation="border" variant="primary" />
                      <p>Searching...</p>
                    </div>
                  )}
                  {checked?.length > 0 && (
                    <div
                      id="user-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="projects-tbl"
                        className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
                      >
                        <thead>
                          <tr>
                            <th className="sorting_asc_11">
                              <div className="form-check custom-checkbox ms-0">
                                <input
                                  type="checkbox"
                                  className="form-check-input checkAllInput"
                                  required=""
                                  onClick={() => handleCheckedAll(unchecked)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="checkAll"
                                ></label>
                              </div>
                            </th>
                            <th>Title</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Office</th>
                            <th>Vehicle Registration Number</th>
                            <th>Driving License</th>
                            <th>Registration Date</th>
                            {searchAnds.some((s) => s.field === "enrollMentExpiryDate") ||
                            searchOrs.some((s) => s.field === "enrollMentExpiryDate") ? (
                              <th>Enrolment Letter Expiry Date</th>
                            ) : null}
                            {searchAnds.some((s) => s.field === "rtwExpiryDate") ||
                            searchOrs.some((s) => s.field === "rtwExpiryDate") ? (
                              <th>RTW Check Expiry Date</th>
                            ) : null}
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {checked.map((item, index) => (
                            <tr key={index}>
                              <td className="sorting_20">
                                <div className="form-check11custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`user-${item._id}`}
                                    checked={item.inputchecked}
                                    onChange={() => handleChecked(item._id)}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`user-${item._id}`}
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <p className="mb-0 ms-2">{item.title}</p>
                                </div>
                              </td>
                              <td>{item.firstName}</td>
                              <td>{item.lastName}</td>
                              <td>{item.email}</td>
                              <td>{item.office}</td>
                              <td>{item?.vehicleLicense || "--"}</td>
                              <td>{item?.drivingLicense || "--"}</td>
                              <td>{dateFormat(item.regDate)}</td>
                              {searchAnds.some((s) => s.field === "enrollMentExpiryDate") ||
                              searchOrs.some((s) => s.field === "enrollMentExpiryDate") ? (
                                <td>
                                  {item.complianceCriteria?.find(
                                    (c) => c.question === "Enrolment Letter Expiry Date"
                                  )?.expireDate &&
                                    dateFormat(
                                      item.complianceCriteria?.find(
                                        (c) => c.question === "Enrolment Letter Expiry Date"
                                      )?.expireDate
                                    )}
                                </td>
                              ) : null}
                              {searchAnds.some((s) => s.field === "rtwExpiryDate") ||
                              searchOrs.some((s) => s.field === "rtwExpiryDate") ? (
                                <td>
                                  {item.complianceCriteria?.find(
                                    (c) => c.question?.toLowerCase()?.includes("rtw")
                                  )?.expireDate &&
                                    dateFormat(
                                      item.complianceCriteria?.find(
                                        (c) => c.question?.toLowerCase()?.includes("rtw")
                                      )?.expireDate
                                    )}
                                </td>
                              ) : null}
                              <td>
                                <Status status={item.status} />
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <Dropdown.Item
                                    onClick={() => {
                                      nav(
                                        `/add-candidate?id=${item._id}&mode=view`
                                      );
                                    }}
                                    style={{ color: "blue" }} // Blue color for the eye icon
                                  >
                                    <i className="bi bi-eye"></i>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      nav(
                                        `/add-candidate?id=${item._id}&mode=edit`
                                      );
                                    }}
                                    style={{ color: "red" }} // Red color for the edit icon
                                  >
                                    <i className="bi bi-pen"></i>
                                  </Dropdown.Item>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="d-sm-flex text-center justify-content-between align-items-center">
                        <div className="dataTables_info">
                          Showing {lastIndex - recordsPage + 1} to {lastIndex}{" "}
                          of {candidates.length} entries
                        </div>
                        <div
                          className="dataTables_paginate paging_simple_numbers justify-content-center"
                          id="example2_paginate"
                        >
                          <Link
                            className="paginate_button previous disabled"
                            to="#"
                            onClick={prePage}
                          >
                            <i className="fa-solid fa-angle-left" />
                          </Link>
                          <span>
                            {number.map((n, i) => (
                              <Link
                                className={`paginate_button ${
                                  currentPage === n ? "current" : ""
                                } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            ))}
                          </span>
                          <Link
                            className="paginate_button next"
                            to="#"
                            onClick={nextPage}
                          >
                            <i className="fa-solid fa-angle-right" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <SendEmail
        ref={userdata}
        Title="Send Email"
        token={token}
        user={loggedInUser}
        data={checked.filter((d) => d.inputchecked)}
      />
      <SendLetter
        ref={sendletterref}
        token={token}
        data={checked.filter((d) => d.inputchecked)}
        isCompany={false}
        user={loggedInUser}
      />

      {/* Company Selector Modal */}
      <Modal
        className="fade"
        show={showCompanySelector}
        onHide={() => setShowCompanySelector(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Companies</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search companies..."
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                // Filter companies based on search term
                // This will be handled by the availableCompanies state
              }}
            />
          </div>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {availableCompanies.map((company) => (
              <div key={company._id} className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`company-${company._id}`}
                  checked={selectedCompanies.some(c => c._id === company._id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const updated = [...selectedCompanies, company];
                      setSelectedCompanies(updated);
                    } else {
                      const updated = selectedCompanies.filter(c => c._id !== company._id);
                      setSelectedCompanies(updated);
                    }
                  }}
                />
                <label className="form-check-label" htmlFor={`company-${company._id}`}>
                  {company.companyName} ({company.candidateCount} candidates)
                </label>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCompanySelector(false)}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={() => {
              // Update the search field with selected company IDs
              const companyIds = selectedCompanies.map(c => c._id).join(',');
              const currentSearchIndex = searchAnds.findIndex(s => s.field === 'previouslyWorkedByCompany');
              if (currentSearchIndex !== -1) {
                handleInputChange(currentSearchIndex, "value", companyIds);
              }
              setShowCompanySelector(false);
            }}
          >
            Select Companies
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="fade"
        show={ai}
        onHide={() => {
          setAi(false);
        }}
        centered
      >
        <Modal.Header>
          <Modal.Title>What you want to search in candidates ?</Modal.Title>
          <Button
            onClick={() => setAi(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            value={text}
            className="form-control"
            onChange={(e) => settext(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setAi(false)} variant="danger light">
            Close
          </Button>
          <Button variant="primary" onClick={() => searchAi()}>
            {isLoading ? <Spinner size="sm" /> : "Search"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),
  };
};

export default withRouter(connect(mapStateToProps)(SearchCandidate));
